import FavoriteComponent from "../components/favorite-component";
import {setFavorite} from "../require/set-favorite";
import {RenderPosition, render} from "../utils/render";
import {setFavoritesHeader} from "../utils/set-favorites-header";

export default class FavoritesController {
  constructor({className = ``, itemId = ``, isCheck = false, renderPosition = RenderPosition.BEFOREEND, onChangeData = () => {}}) {
    this._className = className;
    this._itemId = itemId;
    this._isCheck = isCheck;
    this._renderPosition = renderPosition;
    this._onChangeData = onChangeData;

    this._onClickHandler = this._onClickHandler.bind(this);
  }

  render(container) {
    if (!this._itemId) {
      return;
    }

    const favoriteButtonComponent = new FavoriteComponent({
      className: this._className,
      isCheck: this._isCheck,
    });

    favoriteButtonComponent.setClickHanlder(this._onClickHandler);

    render(container, favoriteButtonComponent.getElement(), this._renderPosition);
  }

  _onClickHandler(cb) {
    this._isCheck = !this._isCheck;

    setFavorite(this._itemId, this._isCheck, (response) => {
      cb(this._isCheck);
      setFavoritesHeader(response.favorites_count);
      this._onChangeData(this._isCheck);
    });
  }
}
